export default __webpack_public_path__ + "static/media/landingBackground5.eaebf0f5.png";